(function () {
  'use strict';

  function pad(num) {
    return String(Math.max(0, num)).padStart(2, '0');
  }

  // Parses "YYYY-MM-DD HH:MM" as UTC so every visitor computes the exact
  // same absolute timestamp, regardless of their local timezone.
  function parseUtc(dateString) {
    if (!dateString) return null;
    var normalized = dateString.trim().replace(' ', 'T');
    if (!/Z$/.test(normalized)) {
      normalized += 'Z';
    }
    var time = new Date(normalized).getTime();
    return isNaN(time) ? null : time;
  }

  function getFixedEndTime(dateString) {
    return parseUtc(dateString);
  }

  // Fully deterministic: given a fixed global start anchor and a cycle
  // length, computes the end of the *current* cycle purely from wall-clock
  // time. No per-visitor state (no localStorage/session) is involved, so
  // every visitor sees exactly the same remaining time.
  function getCycleEndTime(cycleStartString, cycleHours) {
    var anchor = parseUtc(cycleStartString);
    if (anchor === null) return null;

    var cycleMs = (parseFloat(cycleHours) || 1) * 60 * 60 * 1000;
    var now = Date.now();

    if (now < anchor) {
      return anchor + cycleMs;
    }

    var elapsed = now - anchor;
    var cyclesElapsed = Math.floor(elapsed / cycleMs) + 1;
    return anchor + cyclesElapsed * cycleMs;
  }

  function initTimer(el) {
    var mode = el.getAttribute('data-mode') || 'fixed';
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');

    if (!hoursEl || !minutesEl || !secondsEl) return;

    function computeEndTime() {
      if (mode === 'renew') {
        var cycleStart = el.getAttribute('data-cycle-start');
        var cycleHours = el.getAttribute('data-cycle-hours');
        return getCycleEndTime(cycleStart, cycleHours);
      }
      var fixedDate = el.getAttribute('data-end');
      return getFixedEndTime(fixedDate);
    }

    function tick() {
      var endTime = computeEndTime();

      if (endTime === null) {
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      var remaining = endTime - Date.now();

      if (remaining <= 0) {
        if (mode === 'renew') {
          // Recompute immediately: the formula always yields the next
          // cycle, so this self-corrects without drift.
          endTime = computeEndTime();
          remaining = endTime - Date.now();
        } else {
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    var intervalId = setInterval(tick, 1000);

    document.addEventListener('shopify:section:unload', function cleanup(evt) {
      var section = el.closest('[id^="AnnouncementBarTimer-"]');
      if (section && evt.target && evt.target.id === section.id) {
        clearInterval(intervalId);
        document.removeEventListener('shopify:section:unload', cleanup);
      }
    });
  }

  function initRotation(track) {
    var items = track.querySelectorAll('.abt-item');
    if (items.length < 2) return;

    var speed = parseInt(track.getAttribute('data-abt-autoplay'), 10) || 6;
    var current = 0;

    setInterval(function () {
      items[current].classList.remove('abt-item--active');
      current = (current + 1) % items.length;
      items[current].classList.add('abt-item--active');
    }, speed * 1000);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-abt-timer]').forEach(initTimer);
    root.querySelectorAll('[data-abt-track]').forEach(initRotation);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
